import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { apiClient } from '@boothiva/api-client';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@boothiva/ui/styles';
import './styles/app.scss';
import { Providers } from './providers';
import { router } from './router';
apiClient.configure({ origin: window.location.origin, portal: 'customer' });
createRoot(document.getElementById('root')!).render(<StrictMode><Providers router={router} /></StrictMode>);
